import { render, staticRenderFns } from "./OrgIdentityProvider.vue?vue&type=template&id=53d24bec&scoped=true&"
import script from "./OrgIdentityProvider.vue?vue&type=script&lang=js&"
export * from "./OrgIdentityProvider.vue?vue&type=script&lang=js&"
import style0 from "./OrgIdentityProvider.vue?vue&type=style&index=0&id=53d24bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d24bec",
  null
  
)

export default component.exports